// データテーブルのシステムプロンプト整形（純関数・DuckDB 非依存）。
//
// 役割: アップロード済みの非空間データテーブルを、エージェントが JOIN 用 SQL を書ける形で
//       システムプロンプト末尾へ列挙するMarkdownに整形する。
//       DuckDB 非依存に切り出して node --test で検証できるようにしている。
// 関係: useAgentSession が buildSystemWithLayers で注入する。テーブルの形は data-service が作る。

// 列ごとのサンプル値を短く整形する。
function formatSampleValues(table, maxCols = 6, maxVals = 8) {
  const columns = table.columns ?? []
  const sample = table.sample ?? []
  if (!columns.length || !sample.length) return ''
  const lines = columns.slice(0, maxCols).map((c) => {
    const vals = sample
      .map((row) => row[c.name])
      .filter((v) => v != null)
      .slice(0, maxVals)
      .map((v) => String(v))
    return `    - ${c.name}: ${vals.join(' / ')}`
  })
  return `\n  値の例:\n${lines.join('\n')}`
}

// アップロード済みデータテーブルをシステムプロンプト末尾へ注入する Markdown へ整形する。
// エージェントが JOIN 用の SQL を書く材料（テーブル名・列・型・サンプル値）を与える。
export function formatDataTablesForPrompt(tables = [], { maxColumns = 40 } = {}) {
  if (!tables.length) return ''
  const blocks = tables.map((t) => {
    const allCols = t.columns ?? []
    const shown = allCols.slice(0, maxColumns)
    const more = allCols.length > maxColumns ? ` …他 ${allCols.length - maxColumns} 列` : ''
    const cols = shown.map((c) => `${c.name}(${c.type})`).join(', ') + more
    return (
      `- テーブル名: ${t.tableId}（${t.rowCount ?? '?'} 行）\n` +
      `  列: ${cols}` +
      formatSampleValues(t)
    )
  })
  return (
    '## アップロード済みデータテーブル（非空間）\n' +
    '位置情報を持たない属性テーブル。run_spatial_sql で空間レイヤーと JOIN できる（結果はレイヤーの' +
    ' geom を残せば新規レイヤー化できる）。結合キーは型不一致・先頭ゼロ落ちを避けるため双方を' +
    ' VARCHAR にキャストする。列名は下記の実在するものだけ使う。\n' +
    blocks.join('\n')
  )
}
